import axios from 'axios';

import { s } from './safe';

export default axios.create({
  baseURL: s(s(window).env).REACT_APP_API_URL,
});
